import React, {useCallback, useEffect, useState} from 'react'
import {
  ContactFileSmsForm,
  ContactFileSmsFormInitValues as initialValues,
} from '../SMSBroadCast/SettingsModel'
import * as Yup from 'yup'
import {FormikProps, useFormik} from 'formik'
import {Button} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import Select from 'react-select'
import {useDropzone} from 'react-dropzone'
import useSenderIdsOptions, {ISenderIdsOption} from '../../hooks/useSenderIdsOptions'
import clsx from 'clsx'
import {useAuth} from '../auth'
import SmsTemplateModal from './Modal/SmsTemplateModal'
import ContactFileAndSmsModal from './Modal/ContactFileAndSmsModal'
import {useThemeMode} from '../../../_metronic/partials'
import {CapitalizeFirstLetter} from '../Users/AddressForm'
import toast from 'react-hot-toast'
import * as xlsx from 'xlsx'
import useSms from './hook/useSms'
import {TemplateText, VarInputs} from './core/_model'
import {getCurrentTimestamp} from './core/helper'
import SelectSender from './SelectSender'
import FlatPickrDateTime from '../../utils/components/FlatPickrDateTime'

export interface SendingContactFileData {
  campaignName?: string
  senderId: number
  smsType: number
  smsLength: number
  smsPart: number | undefined
  smsContent: string
  sendNow: number
  scheduleDate: string
  variables: any
}

export type CSVData = {
  [key: string]: string
}

const contactSmsSchema = Yup.object().shape({
  senderid: Yup.object().required('Sender Id is required'),
  contact_file: Yup.mixed()
    .required('Contact file is required')
    .test('fileFormat', 'Only CSV and Excel file can be upload', (value: any) => {
      if (value) {
        const supportedFormat = ['csv', 'xls', 'xlsx']
        return supportedFormat.includes(value.name.split('.').pop())
      }
      return true
    }),
  sms_content: Yup.string().required('SMS content is required.'),
})

const ContactFileSMS: React.FC = () => {
  const {currentUser} = useAuth()
  const {smsState, handleSmsContentChange, handleSmsTypeChange, backToCountDefault} = useSms()
  const {mode} = useThemeMode()

  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState<ContactFileSmsForm>(initialValues)
  const [templateText, setTemplateText] = useState<TemplateText>({
    isUse: false,
    smsText: '',
    isSmartTemplate: 0,
  })
  const [defaultSender, setDefaultSender] = useState<ISenderIdsOption | null>(null)
  const [smartVarField, setSmartVarField] = useState<string[]>([])
  const [varInputs, setVarInputs] = useState<VarInputs | undefined>(undefined)
  const [isCreated, setIsCreated] = useState(false)

  const providedCmName = `${currentUser?.user_full_name}- ${getCurrentTimestamp()}`

  const checkVarInputs = Object.values(varInputs ?? {}).every((value) => value !== '')

  const formik: FormikProps<ContactFileSmsForm> = useFormik({
    initialValues,
    validationSchema: contactSmsSchema,
    onSubmit: async (values) => {
      await validateFile(values.contact_file)
      setFormData({
        ...values,
        sms_count: smsState.noOfSms,
        smsTextCharacterCount: smsState.characterCount,
        noOfSms:
          (typeof values?.reciepient === 'number' ? values.reciepient : 0) * smsState.noOfSms,
        sms_type: smsState.smsType,
      })
      if (checkVarInputs) {
        console.log(values)
      }
    },
  })

  useEffect(() => {
    validateFile(formik.values.contact_file)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.contact_file])

  const validateFile = async (file: File | string) => {
    if (typeof file === 'string') {
      return
    }

    const fileType = file.name.split('.').pop()?.toLowerCase()
    if (fileType === 'csv') {
      await validateCSV(file)
    } else if (fileType === 'xlsx' || fileType === 'xls') {
      await validateExcel(file)
    } else {
      toast.error('Unsupported file type. Please upload a CSV or Excel file.')
    }
  }

  const validateExcel = async (file: File) => {
    try {
      const reader = new FileReader()
      reader.onload = async (event) => {
        const data = new Uint8Array(event.target?.result as ArrayBuffer)
        const workbook = xlsx.read(data, {type: 'array'})

        const sheet = workbook.Sheets[workbook.SheetNames[0]]

        const jsonData = xlsx.utils.sheet_to_json<CSVData>(sheet)

        const allNumbers = jsonData.every(
          (row: CSVData) => !isNaN(Number(row[Object.keys(row)[0]]))
        )

        if (allNumbers) {
          const count = jsonData.length
          formik.setFieldValue('reciepient', count)
        } else {
          toast.error('Values should be numbers')
          formik.setFieldValue('reciepient', 0)
        }
      }
      reader.readAsArrayBuffer(file)
    } catch (error) {
      console.error(error)
    }
  }

  const validateCSV = async (file: File) => {
    try {
      const fileUrl = URL.createObjectURL(file)
      const response = await fetch(fileUrl)

      // Check if the response is ok
      if (response.ok) {
        const text = await response.text()
        const lines = text.split('\n')
        console.log(lines)

        // Count the rows where the first column contains numbers
        let count = 0
        lines.forEach((line) => {
          const columns = line.split(',')
          console.log(columns)
          if (!isNaN(Number(columns[0]))) {
            count++
          }
        })

        formik.setFieldValue('reciepient', count - 1)
      } else {
        toast.error(`Something went wrong, try again`)
      }
    } catch (error: any) {
      console.error(error)
      toast.error(`Error: ${error.message}`)
    }
  }

  const handleCancel = () => {
    formik.resetForm()
    formik.setFieldValue('cm_name', providedCmName)
    formik.setFieldValue('senderid', defaultSender)
    setIsCreated(false)
    setFormData(initialValues)
    setSmartVarField([])
    backToCountDefault()
    console.log(formik.values)
  }

  // console.log(formik.values)

  if (isCreated) {
    handleCancel()
  }

  if (templateText.isUse) {
    formik.setFieldValue('sms_content', templateText.smsText)
    setTemplateText({
      isUse: false,
      smsText: templateText.smsText,
      isSmartTemplate: templateText.isSmartTemplate,
    })
  }

  const onFileDrop = useCallback((acceptedFiles: any) => {
    formik.setFieldValue('contact_file', acceptedFiles[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const {acceptedFiles, getRootProps, getInputProps} = useDropzone({onDrop: onFileDrop})

  const files = acceptedFiles.map((file) => (
    <li key={file.name}>
      {file.name} - {file.size} bytes
    </li>
  ))

  const smartTemplate = (text: string) => {
    const regex = /#(.*?)#/g
    const matches = []
    let match

    // Loop over all matches and push the capturing group into the matches array
    while ((match = regex.exec(text)) !== null) {
      matches.push(match[1])
    }

    setSmartVarField(matches)

    const dynamicInputs = matches.reduce<Record<string, string>>((acc, match) => {
      acc[match] = ''
      return acc
    }, {})

    setVarInputs(dynamicInputs)
  }

  const handleVarFieldsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = event.target
    setVarInputs((prevData: any) => ({
      ...prevData,
      [name]: value,
    }))
  }

  useEffect(() => {
    // smartTemplate('hello #name# #age#')
    if (templateText.isSmartTemplate) {
      smartTemplate(templateText.smsText)
    } else {
      setSmartVarField([])
      setVarInputs(undefined)
    }
  }, [templateText])

  useEffect(() => {
    document.title = 'Contact File SMS'
    formik.setFieldValue('cm_name', providedCmName)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0 cursor-pointer'>
        <div className='card-title m-0'>
          <h3 className='er m-0'>
            Contact File SMS <span className='form-text'>:: upload contacts from file</span>
          </h3>
        </div>
      </div>

      <div>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='row mb-4'>
              <label className='col-lg-4 col-form-label  fs-6'>
                <span className='required'>Campaign Name</span>
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  name='cm_name'
                  placeholder='Campaign Name'
                  className={clsx(
                    'form-control form-control-lg custom-input',
                    {'is-invalid': formik.touched.cm_name && formik.errors.cm_name},
                    {
                      'is-valid': formik.touched.cm_name && !formik.errors.cm_name,
                    }
                  )}
                  value={formik.values.cm_name}
                  onChange={formik.handleChange}
                />
                {formik.touched.cm_name && formik.errors.cm_name && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.cm_name}</div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-4'>
              <label className='col-lg-4 col-form-label  fs-6'>
                <span className='required'>Select Sender ID</span>
              </label>

              <div className='col-lg-8 fv-row'>
                <SelectSender formik={formik} setDefaultSender={setDefaultSender} />

                {formik.touched.senderid && formik.errors.senderid && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.senderid}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required  fs-6'>Select Contact File</label>
              <div className='col-lg-8 fv-row-3'>
                <section className='container'>
                  <div {...getRootProps({className: 'dropzone'})}>
                    <input {...getInputProps()} />
                    <p>Drag 'n' drop excel or csv file here, or click to select files</p>
                  </div>

                  {formik.touched.contact_file && formik.errors.contact_file && (
                    <div className='fv-plugins-message-container'>
                      00
                      <div className='fv-help-block'>{formik.errors.contact_file}</div>
                    </div>
                  )}
                  <aside>
                    <p className='mt-2 text-success fs-6 fw-semibold'>
                      First Column must contain mobile numbers
                    </p>
                    <p className='fs-4 fw-bold'>File</p>
                    {/* <ul>{!formik.isValid ? files : null}</ul> */}
                    <ul>{formik.values.contact_file === '' ? null : files}</ul>
                  </aside>
                </section>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fs-6'>Select SMS Type</label>

              <div className='col-lg-8 fv-row'>
                <div className='d-flex align-items-center mt-3'>
                  <label className='form-check form-check-inline form-check-solid me-5'>
                    <input
                      className='form-check-input'
                      name='sms_type'
                      type='radio'
                      value={0}
                      checked={smsState.smsType === 0}
                      onChange={(e) => {
                        handleSmsTypeChange(e)
                      }}
                    />
                    <span className=' ps-2 fs-6'>Text</span>
                  </label>

                  <label className='form-check form-check-inline form-check-solid'>
                    <input
                      className='form-check-input'
                      name='sms_type'
                      type='radio'
                      value={1}
                      checked={smsState.smsType === 1}
                      onChange={(e) => {
                        handleSmsTypeChange(e)
                      }}
                    />
                    <span className=' ps-2 fs-6'>UniCode</span>
                  </label>
                </div>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required  fs-6'>Enter Sms Content</label>
              <div className='col-lg-8 fv-row-3'>
                <textarea
                  name='sms_content'
                  className={clsx(
                    'form-control form-control-lg custom-input',
                    {'is-invalid': formik.touched.sms_content && formik.errors.sms_content},
                    {
                      'is-valid': formik.touched.sms_content && !formik.errors.sms_content,
                    }
                  )}
                  placeholder='SMS Content'
                  rows={5}
                  style={{resize: 'vertical', fontSize: '1.0rem'}}
                  value={formik.values.sms_content}
                  onChange={(e) => {
                    handleSmsContentChange(e)
                    formik.handleChange(e)
                    if (smsState.characterCount === 0) {
                      setSmartVarField([])
                      setVarInputs(undefined)
                    }
                  }}
                ></textarea>
                {formik.touched.sms_content && formik.errors.sms_content && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.sms_content}</div>
                  </div>
                )}
                <div className='form-text'>
                  {smsState.characterCount} Characters | {smsState.noOfSms} SMS |{' '}
                  {smsState.noOfSms > 1 ? smsState.charPerSmsForLong : smsState.charPerSms} Char/SMS{' '}
                  <span>
                    <button
                      className='px-4 rounded border-0 bg-success fw-semibold text-white'
                      type='button'
                      data-bs-toggle='modal'
                      data-bs-target='#kt_modal_3'
                    >
                      Insert SMS Template
                    </button>
                  </span>{' '}
                </div>
              </div>
            </div>

            {templateText.isSmartTemplate && varInputs
              ? smartVarField.map((field: string, index: number) => {
                  return (
                    <div className='row mb-4' key={index}>
                      <label className='col-lg-4 col-form-label fs-6'>
                        <span className='required'>{CapitalizeFirstLetter(field)}</span>
                      </label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          name={field}
                          placeholder={`Enter ${CapitalizeFirstLetter(field)}`}
                          className={clsx(
                            'form-control form-control-lg form-control-solid',
                            {'is-invalid': varInputs[field]! === ''},
                            {
                              'is-valid': varInputs[field],
                            }
                          )}
                          value={varInputs[field]}
                          onChange={(e) => handleVarFieldsChange(e)}
                        />
                      </div>
                    </div>
                  )
                })
              : null}

            <SmsTemplateModal setTemplateText={setTemplateText} isSmartTemplate={0} />

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fs-6'>Schedule SMS *</label>
              <div className='col-lg-8 fv-row'>
                <div className='d-flex align-items-center mt-3'>
                  <label className='form-check form-check-inline form-check-solid me-5'>
                    <input
                      className='form-check-input'
                      name='sms_schedule'
                      type='radio'
                      value='now'
                      checked={formik.values.sms_schedule === 'now'}
                      onChange={(e) => {
                        formik.setFieldValue('sms_schedule', 'now')
                      }}
                    />
                    <span className='ps-2 fs-6'>Send Now</span>
                  </label>
                  <label className='form-check form-check-inline form-check-solid'>
                    <input
                      className='form-check-input'
                      name='sms_schedule'
                      type='radio'
                      value='later'
                      checked={formik.values.sms_schedule === 'later'}
                      onChange={() => {
                        formik.setFieldValue('sms_schedule', 'later')
                      }}
                    />
                    <span className='ps-2 fs-6'>Send Later</span>
                  </label>
                </div>

                <div className='col-lg-8 mt-4'>
                  {formik.values.sms_schedule === 'later' ? (
                    <div id='sms_schedule' className='sms-schedule'>
                      <FlatPickrDateTime
                        placeholder='Click to select date time'
                        fieldName='schedule_date'
                        formik={formik}
                        container='sms_schedule'
                        dateformat='Y-m-d h:i K'
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button
              type='button'
              className='btn btn-danger me-2'
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type='submit'
              className='btn btn-primary'
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_1'
              disabled={loading}
            >
              {!loading && 'Review'}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </form>
        <ContactFileAndSmsModal
          formData={formData}
          setIsCreated={setIsCreated}
          setLoading={setLoading}
          formik={formik}
          varInputs={varInputs}
        />
      </div>
    </div>
  )
}

export {ContactFileSMS}
